export default "__VITE_ASSET__BPNscLzW__"